import {
  REQUEST_REPROCESS_UNITS,
  RESPONSE_REPROCESS_UNITS,
  REQUEST_REPROCESS_UNITS_FAILURE,
  REQUEST_CREATE_REPROCESS_UNIT,
  RESPONSE_CREATE_REPROCESS_UNIT,
  REQUEST_CREATE_REPROCESS_UNIT_FAILURE,
  REQUEST_DELETE_REPROCESS_UNIT,
  RESPONSE_DELETE_REPROCESS_UNIT,
  REQUEST_DELETE_REPROCESS_UNIT_FAILURE,
  REQUEST_REPROCESS_TYPES,
  RESPONSE_REPROCESS_TYPES,
  REQUEST_REPROCESS_TYPES_FAILURE,
} from "../actions/reprocessUnitsActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  reprocessUnitsDataState: queriesStates.NOT_REQUESTED,
  createReprocessUnitsDataState: queriesStates.NOT_REQUESTED,
  deleteReprocessUnitsDataState: queriesStates.NOT_REQUESTED,
  reprocessTypesDataState: queriesStates.NOT_REQUESTED,
  lastSchedulerTime: null,
  reprocessUnits: [],
  errors: [],
};

const reprocessUnitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_REPROCESS_UNITS: {
      return Object.assign({}, state, {
        reprocessUnitsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_REPROCESS_UNITS: {
      return Object.assign({}, state, {
        reprocessUnitsDataState: queriesStates.READY,
        reprocessUnits: action.data.reprocessUnits,
        lastSchedulerTime: action.data.lastSchedulerTime,
      });
    }
    case REQUEST_REPROCESS_UNITS_FAILURE: {
      return Object.assign({}, state, {
        reprocessUnitsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_CREATE_REPROCESS_UNIT: {
      return Object.assign({}, state, {
        createReprocessUnitsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_REPROCESS_UNIT: {
      return Object.assign({}, state, {
        createReprocessUnitsDataState: queriesStates.READY,
        reprocessUnits: state.reprocessUnits.concat(action.data),
      });
    }
    case REQUEST_CREATE_REPROCESS_UNIT_FAILURE: {
      return Object.assign({}, state, {
        createReprocessUnitsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_REPROCESS_UNIT: {
      return Object.assign({}, state, {
        deleteReprocessUnitsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_REPROCESS_UNIT: {
      return Object.assign({}, state, {
        deleteReprocessUnitsDataState: queriesStates.READY,
        reprocessUnits: state.reprocessUnits.filter((x) => {
          return x.id !== action.data.id;
        }),
      });
    }
    case REQUEST_DELETE_REPROCESS_UNIT_FAILURE: {
      return Object.assign({}, state, {
        deleteReprocessUnitsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_REPROCESS_TYPES: {
      return Object.assign({}, state, {
        reprocessTypesDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_REPROCESS_TYPES: {
      const types = {};

      action.data.typeReprocesses.forEach((item) => {
        types[item.id] = item.title
      });

      return Object.assign({}, state, {
        reprocessTypesDataState: queriesStates.READY,
        reprocessTypes: types,
      });
    }
    case REQUEST_REPROCESS_TYPES_FAILURE: {
      return Object.assign({}, state, {
        reprocessTypesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default reprocessUnitsReducer;
